import { createFileRoute } from '@tanstack/react-router'

import { PlatformAnnouncementEditionPage } from '../../../../components/pages/backoffice/platform/platform-announcements-page/platform-announcement-form-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/announcements/$announcementId/')({
  component: function Component() {
    const { announcementId } = Route.useParams()

    return (
      <PermissionChecker requiredPermissions={['backofficeAnnouncement.update']}>
        <PlatformAnnouncementEditionPage announcementId={announcementId} />
      </PermissionChecker>
    )
  },
})
